export default __webpack_public_path__ + "static/media/cumber.9b4e5c6e.jpg";